import './styles.scss';
import { InputChoices } from 'views/components/molecules/establishes/inputChoices';
import {
  InvestmentInfoFormikType,
  PolicyStrs,
  AnnualIncomeStrs,
  FinancialAssetsStrs,
  Experiences,
  FormErrorScrollTarget,
  Policy,
} from 'views/utils/accountEstablish';
import { Button, ButtonProps } from 'views/components/atoms/button';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { CheckBoxGloup } from 'views/components/molecules/checkBoxGroup';

type InvestmentInfoTemplateType = {
  formik: InvestmentInfoFormikType;
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
    confirmButtonProps: ButtonProps;
    isPrevPageConfirm: boolean;
  };
};

export const InvestmentInfoTemplate = ({ formik, buttonProps }: InvestmentInfoTemplateType) => {
  return (
    <>
      <div className="establishWrapper ">
        <div className="establishWrapper_announce">
          <h1>取引の種類</h1>
          <h2>受益証券発行信託の受益証券の募集の取扱い・売買</h2>
        </div>
      </div>

      <div className="establishWrapper">
        <div className="inputWrapper">
          {!!formik.errors.investmentExperiences && <FormErrorScrollTarget />}
          <EstablishHeader headerTitle={'証券投資のご経験'} batchDangerWord="必須（複数選択可）" />
          <CheckBoxGloup
            items={formik.values.investmentExperiences}
            cb={(items) => {
              formik.setFieldValue('investmentExperiences', items);
            }}
            exclusiveItem={Experiences.NO_EXPERIENCE}
          />
          <EstablishError
            isEnabled={!!(formik.errors.investmentExperiences as string)}
            errorText={formik.errors.investmentExperiences as string}
          />
        </div>
      </div>

      <div className="establishWrapper">
        {!!formik.errors.investmentPolicy && <FormErrorScrollTarget />}
        <InputChoices
          title="ご投資の方針"
          batchDangerWord="必須"
          selectedOption={formik.values.investmentPolicy ? formik.values.investmentPolicy : ''}
          setSelectedOption={(selectedOption) => formik.setFieldValue('investmentPolicy', selectedOption)}
          options={PolicyStrs}
          isEnabled={!!formik.errors.investmentPolicy}
          errorText={formik.errors.investmentPolicy}
        />
        {formik.values.investmentPolicy === Policy.PRINCIPAL ? (
          <div className="investmentPolicyAnnounce">
            <span>元本重視とは、預金、MMFなど、元本の安全性を最重要とするお客様</span>
          </div>
        ) : formik.values.investmentPolicy === Policy.INTEREST_DICIDEND ? (
          <div className="investmentPolicyAnnounce">
            <span>
              利子・配当重視とは、国債、地方債、格付けの高い円建て債券など、安定した利回り運用を志向されるお客様
            </span>
          </div>
        ) : formik.values.investmentPolicy === Policy.BALANCE ? (
          <div className="investmentPolicyAnnounce">
            <span>
              利子・配当と値上がり益のバランスを重視とは、国内上場株式、国内外の投信、円建て社債、外国債券など、ある程度のリスクを勘案し利回りと収益性のバランスに配慮した資産運用を志向されるお客様
            </span>
          </div>
        ) : formik.values.investmentPolicy === Policy.PROFIT ? (
          <div className="investmentPolicyAnnounce">
            <span>
              値上がり益を重視とは、国内上場株式、外国株、新興国へ投資する投信、仕組債など、リスクを勘案し収益性を重視した資産運用を志向されるお客様
            </span>
          </div>
        ) : formik.values.investmentPolicy === Policy.PROFIT_PROACTIVE ? (
          <div className="investmentPolicyAnnounce">
            <span>
              値上がり益を積極追求とは、外国株、新興国へ投資する投信、信用取引、デリバティブ取引など、より大きなリスクを勘案しながら積極的に投資運用を志向されるお客様
            </span>
          </div>
        ) : (
          <></>
        )}
      </div>

      <div className="establishWrapper">
        <div className="inputWrapper">
          {!!formik.errors.investmentPurposes && <FormErrorScrollTarget />}
          <EstablishHeader headerTitle={'弊社ご利用にあたってのご投資目的'} batchDangerWord="必須（複数選択可）" />
          <CheckBoxGloup
            items={formik.values.investmentPurposes}
            cb={(items) => {
              formik.setFieldValue('investmentPurposes', items);
            }}
          />
          <EstablishError
            isEnabled={!!(formik.errors.investmentPurposes as string)}
            errorText={formik.errors.investmentPurposes as string}
          />
        </div>
      </div>

      <div className="establishWrapper">
        {!!formik.errors.annualIncome && <FormErrorScrollTarget />}
        <InputChoices
          title="年収"
          batchDangerWord="必須"
          selectedOption={formik.values.annualIncome ? formik.values.annualIncome : ''}
          setSelectedOption={(selectedOption) => formik.setFieldValue('annualIncome', selectedOption)}
          options={AnnualIncomeStrs}
          isEnabled={!!formik.errors.annualIncome}
          errorText={formik.errors.annualIncome}
        />
      </div>

      <div className="establishWrapper">
        <div className="inputWrapper">
          {!!formik.errors.incomeForm && <FormErrorScrollTarget />}
          <EstablishHeader headerTitle={'収入形態'} batchDangerWord="必須（複数選択可）" />
          <CheckBoxGloup
            items={formik.values.incomeForm}
            cb={(items) => {
              formik.setFieldValue('incomeForm', items);
            }}
          />
          <EstablishError
            isEnabled={!!(formik.errors.incomeForm as string)}
            errorText={formik.errors.incomeForm as string}
          />
        </div>
      </div>

      <div className="establishWrapper">
        {!!formik.errors.financialAssets && <FormErrorScrollTarget />}
        <InputChoices
          title="金融資産"
          batchDangerWord="必須"
          selectedOption={formik.values.financialAssets ? formik.values.financialAssets : ''}
          setSelectedOption={(selectedOption) => formik.setFieldValue('financialAssets', selectedOption)}
          options={FinancialAssetsStrs}
          isEnabled={!!formik.errors.financialAssets}
          errorText={formik.errors.financialAssets}
        />
      </div>

      {buttonProps && (
        <div className="establishWrapper">
          {buttonProps.isPrevPageConfirm ? (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.confirmButtonProps} />
            </div>
          ) : (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.prevButtonProps} />
              <Button {...buttonProps.nextButtonProps} />
            </div>
          )}
        </div>
      )}
    </>
  );
};
